// extracted by mini-css-extract-plugin
export var createdDate = "_jq-1";
export var divider = "_jq-2";
export var headerDivider = "_jq-3";
export var messagesCard = "_jq-0";
export var messagesContainer = "_jq-6";
export var messagesContainerWrapper = "_jq-4";
export var showLeftPanelButton = "_jq-8";
export var topButtons = "_jq-7";
export var withPadding = "_jq-5";